import { render, staticRenderFns } from "./cpiContainerTab.vue?vue&type=template&id=7bf6f402&lang=pug"
import script from "./cpiContainerTab.vue?vue&type=script&lang=js"
export * from "./cpiContainerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports